import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';

import { IFavoritesTeams } from '@/app/models/favorite/team-favorites.model';
import { NewTeamFavoritesService } from '@/app/services/favorite';
import { RoutingService } from '@/app/services/routing.service';
import { TranslationService } from '@/app/services/translation.service';
import { environment } from '@environments/environment';
import { ITeamSummaryApi } from '../../models';

@Component({
  selector: 'app-detail-view',
  standalone: true,
  imports: [],
  templateUrl: './detail-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailViewComponent {
  private fTeamService = inject(NewTeamFavoritesService);
  private routingService = inject(RoutingService);
  private translationService = inject(TranslationService);

  teamInfo = input.required<ITeamSummaryApi | null>();

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  isFavorite = computed(
    () =>
      this.fTeamService.favoritesService
        .idsTeamFavorites()
        .includes(this.teamInfo()!.Id) ?? false
  );

  getNameTeam() {
    if (!this.teamInfo()) return '';

    return this.translationService.getTraduccionName(
      this.teamInfo()!.NameTranslation as any,
      this.teamInfo()!.Name
    );
  }

  getLogoTeam() {
    return {
      logo: this.teamInfo()?.ImageUrl ?? this.urlIMG + 'default.png',
    };
  }

  onFavoriteTeam() {
    if (!this.teamInfo()) return;

    const bodyData: IFavoritesTeams = {
      CountryName: '',
      CountryNameTranslation: {},
      Id: this.teamInfo()?.Id ?? '',
      ImageUrl: this.teamInfo()?.ImageUrl ?? '',
      IsFavorite: this.teamInfo()?.IsFavorite ?? false,
      Name: this.teamInfo()?.Name ?? '',
      NameTranslation: this.teamInfo()?.NameTranslation ?? {},
      TsExternalId: this.teamInfo()?.TsExternalId ?? '',
      Link: this.routingService.getTraslateUrlTeamDetails(
        this.teamInfo()?.NameTranslation ?? {},
        this.teamInfo()?.Name || '',
        this.teamInfo()?.Id ?? ''
      ),
    };

    if (this.isFavorite()) {
      this.fTeamService.deleteTeamFavorites(bodyData.Id);
    } else {
      this.fTeamService.setTeamFavorites(bodyData);
    }
  }
}
